import { IAppService, IStateConfig, IFxpAppContext, IServiceEndPoints, IRouteInfo, IPartnerBundle } from '@fxp/fxpservices';
import { appSettings, applicationName } from './environments/common/appsettingsGenerator';
import { PartnerAppRegistrationService } from '@fxp/fxpservices';

export class UnitsManagement_routes implements IAppService {

  getAuthExceptionEndpoints(): Array<any> {
    return [];
  }

  getRoutes(fxpContext: IFxpAppContext): IRouteInfo {    

    const unitSubmissionAppRoute: IStateConfig = {
      name: 'UnitSubmission',
      url: '/um/unitsubmission',
      componentFramework: 'React',
      data: {
        headerName: 'Units Submission',
        breadcrumbText: 'UnitSubmission',
        pageTitle: 'UnitSubmission',
        partnerTelemetryName: 'Unit Management'
      }
    }  

    const unitApprovalAppRoute: IStateConfig = {
      name: 'UnitApproval',
      url: '/um/unitapproval',
      componentFramework: 'React',
      data: {
        headerName: 'Unit Approval',
        breadcrumbText: 'UnitApproval',
        pageTitle: 'Unit Approval',
        partnerTelemetryName: 'Unit Management'
      }
    }  


    const routeInfo: IRouteInfo = {
      applicationName: "UnitsManagement",
      sharedBundles: ["UnitsManagement-bundle"],
      routes: [unitSubmissionAppRoute, unitApprovalAppRoute]
    }

    return routeInfo;
  }

  getServiceEndPoints(): Array<IServiceEndPoints> {

    return appSettings().serviceEndPoints;
  }

  getBundles(): IPartnerBundle[] {
    const baseUrl = appSettings().cdnBaseUrl;
    const bundle: IPartnerBundle = {
      name: "UnitsManagement-bundle",
      files: [
        `${baseUrl}/vendor.bundle.js`,
        `${baseUrl}/styles.bundle.js`,
        `${baseUrl}/main.bundle.js`,
      ],
      sequentialLoading: true,
    };

    return [bundle];
  }
}

PartnerAppRegistrationService.registerLazyLoadedApp(UnitsManagement_routes);
